module.exports = __webpack_public_path__ + "img/KSC04151.01b840bd.jpg";